import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import InlineErrorView from '@bingads-webui-campaign-legacy/editorial-appeal/view/inline-error';
import '@bingads-webui-campaign/ko-stop-binding';
import { getRequestFormStyle } from './style';

export const LegacyInlineErrorView = React.memo(({
  id, className,
}) => {
  const view = useRef();
  let container;

  useEffect(() => {
    view.current = new InlineErrorView({ rowId: 'bulk', useKwCss: true });

    view.current.render();
    view.current.$el.appendTo(container);

    return () => {
      view.current.remove();
    };
  }, [container]);

  const classes = useDefaultStyles(getRequestFormStyle);

  return (
    <div
      id={id}
      className={classnames(className, classes.requestFormContainer)}
    >
      <div ref={(ref) => { container = ref; }} />
    </div>
  );
});

LegacyInlineErrorView.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
};

LegacyInlineErrorView.defaultProps = {
  id: undefined,
  className: undefined,
};
